"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("./pim/index");

var _PEPComponent2 = _interopRequireDefault(require("./utils/PEPComponent"));

var _PEPGuideConfig = _interopRequireDefault(require("./utils/PEPGuideConfig"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PEPGuide = /*#__PURE__*/function (_PEPComponent) {
  _inherits(PEPGuide, _PEPComponent);

  var _super = _createSuper(PEPGuide);

  /**
   * Component for implementing a PEP guide
   * @param {string} [selector=pep-guide]
   * @constructor
   * @augments PEPComponent
   * @inheritdoc
   * @example
   *
   * import { PEPGuide } from '@demant/product-experience-page';
   *
   * const myComp = new PEPGuide();
   * myComp.onRender = ({component, dataPromise, guide, labels}) => {
   *  const componentContent = component.querySelector('.component-content');
   *  componentContent.innerHTML = 'Loading data, hold on.';
   *
   *  dataPromise.then((pimData) => {
   *    // products fetched
   *    // render guide
   *  });
   * }
   * myComp.run();
   */
  function PEPGuide() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pep-guide';
    var directPimProducts = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, PEPGuide);

    return _super.call(this, selector, directPimProducts);
  }

  _createClass(PEPGuide, [{
    key: "fetchData",
    value: function fetchData(pim) {
      return pim.fetchHearingInstruments();
    }
  }, {
    key: "postProcessPIMData",
    value: function postProcessPIMData(pimData) {
      var guide = this.config.guide || new _PEPGuideConfig["default"]({});
      pimData.products = pimData.getProducts().filter(function (pimProduct) {
        return guide.productIDs.indexOf(pimProduct.productId) > -1 || guide.productIDs.indexOf("".concat(pimProduct.productId)) > -1;
      });
      return pimData;
    }
  }]);

  return PEPGuide;
}(_PEPComponent2["default"]);

var _default = PEPGuide;
exports["default"] = _default;